import angular from 'angular';

angular.module('cloudX').component('relBudgetProgressbar', {
  bindings: {
    kpi: '<',
    onReload: '&',
    readOnly: '<?',
  },
  template: `<div ng-if="$ctrl.kpi && $ctrl.kpi.data" class="relation-budget-kpi">
      <a class="progress progress-center-info budget-progress"
         uib-popover-template="'budgetInfo.html'"
         popover-placement="bottom"
         popover-title="{{('Budgets'|translate)}}"
         popover-trigger="{'outsideClick':'outsideClick'}">
        <div class="progress-bar {{$ctrl.kpi.data.pbClass}}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" ng-style="$ctrl.kpi.data.pbStyle">
          <span ng-bind="$ctrl.kpi.data.pbPercentage"></span>
        </div>
      </a>
      <script type="text/ng-template" id="budgetInfo.html">
        <div class="relation-budget-kpi-popover">
          <div class="budget-row" ng-repeat="budget in $ctrl.kpi.data.details">
            <h4 ng-if="$ctrl.showAssignments">
              {{budget.invoiceStream|invoiceStreamName}}
              <a ng-click="$ctrl.showBudgetDialog(budget.invoiceStream)"
                 title="{{('EditBudget'|translate)}}"
                 class="pull-right">
                <i class="fa fa-pencil"></i>
              </a>
            </h4>
            <div class="budget" ng-if="budget.budgetAmount!==null || budget.budgetAmountUsed!==null" title="{{('Amount'|translate)}}">
              <label><i class="fa fa-euro fa-fw"></i></label>
              <div class="progress progress-center-info budget-progress">
                <div class="progress-bar {{budget.pbAmountClass}}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" ng-style="budget.pbAmountStyle">
                  <span ng-show="budget.budgetAmount!==null">{{budget.actualAmount| currency}} / {{budget.budgetAmount | currency}}</span>
                  <span ng-show="budget.budgetAmount===null">{{budget.budgetAmountUsed | percentage:0}}</span>
                </div>
              </div>
              <div class="percentage" ng-bind="budget.budgetAmountUsed | percentage:0"></div>
            </div>
            <div class="budget" ng-if="budget.budgetHours!=null" title="{{('Hours'|translate)}}">
              <label><i class="fa fa-clock-o fa-fw"></i></label>
              <div class="progress progress-center-info budget-progress">
                <div class="progress-bar {{budget.pbHoursClass}}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" ng-style="budget.pbHoursStyle">
                  <span>{{budget.actualHours | dynNumber:0:2}} / {{budget.budgetHours | dynNumber:0:2}}</span>
                </div>
              </div>
              <div class="percentage" ng-bind="budget.budgetHoursUsed | percentage:0"></div>
            </div>
            <div ng-if="!$ctrl.showAssignments"
                 class="text-right">
              <a ng-click="$ctrl.showBudgetDialog(budget.invoiceStream)"
                 title="{{('EditBudget'|translate)}}">
                <i class="fa fa-pencil"></i>
              </a>
            </div>
          </div>
          <div class="budget-row budget-total-row" ng-if="$ctrl.kpi.data.details.length>1">
            <h4 data-translate="Total"></h4>
            <div class="budget" ng-if="$ctrl.kpi.data.budgetAmount || $ctrl.kpi.data.budgetAmountUsed!==null" title="{{('Amount'|translate)}}">
              <label><i class="fa fa-euro fa-fw"></i></label>
              <div class="progress progress-center-info budget-progress">
                <div class="progress-bar {{$ctrl.kpi.data.pbAmountClass}}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" ng-style="$ctrl.kpi.data.pbAmountStyle">
                  <span ng-show="$ctrl.kpi.data.budgetAmount!==null">{{$ctrl.kpi.data.actualAmount| currency}} / {{$ctrl.kpi.data.budgetAmount | currency}}</span>
                  <span ng-show="$ctrl.kpi.data.budgetAmount===null">{{$ctrl.kpi.data.budgetAmountUsed | percentage:0}}</span>
                </div>
              </div>
              <div class="percentage" ng-bind="$ctrl.kpi.data.budgetAmountUsed | percentage:0"></div>
            </div>
            <div class="budget" ng-if="$ctrl.kpi.data.budgetHours!==null" title="{{('Hours'|translate)}}">
              <label><i class="fa fa-clock-o fa-fw"></i></label>
              <div class="progress progress-center-info budget-progress">
                <div class="progress-bar {{$ctrl.kpi.data.pbHoursClass}}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" ng-style="$ctrl.kpi.data.pbHoursStyle">
                  <span>{{$ctrl.kpi.data.actualHours | dynNumber:0:2}} / {{$ctrl.kpi.data.budgetHours | dynNumber:0:2}}</span>
                </div>
              </div>
              <div class="percentage" ng-bind="$ctrl.kpi.data.budgetHoursUsed | percentage:0"></div>
            </div>
          </div>

        </div>
      </script>
    </div>`,
  controller: [
    'relBudgetSvc',
    'ModalService',
    'dataCache',
    function(relBudgetSvc, ModalService, dataCache) {
      const ctrl = this;
      ctrl.showAssignments = dataCache.getArray('assignmentsEnabled');

      ctrl.showBudgetDialog = function(invoiceStream) {
        if (!invoiceStream) return;
        ModalService.showModal({
          template: require('../dialogs/invoiceStreamBudgetDialog.html'),
          controller: 'InvoiceStreamBudgetDialogCtrl',
          controllerAs: 'vm',
          locationChangeSuccess: false,
          inputs: {
            stream: invoiceStream,
            readOnly: !!ctrl.readOnly,
          },
        }).then(function(modal) {
          modal.element.modal();
          modal.element.on('hidden.bs.modal', function(e) {
            modal.element.off(e); //Remove event
            modal.element.remove(); //Remove element
          });
          modal.close.then(function(result) {
            if (result) {
              ctrl.onReload();
            }
          });
        });
      };
    },
  ],
});
